import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { MultiselectCategoryListComponentProps, MultiselectCategoryListComponentState } from './multiselectcategorylistcomponent';
import * as React from 'react';
import { BaseContext } from '../../../../../utils/basecontext';
import { HorizontalListComponent, MarginTopType, GutterType, ArrowsPaddingType, ArrowsSizeType } from '../../../../toolkit/horizontallist/horizontallistcomponent';
import { MultiselectCategoryListCSSStyle } from './multiselectcategorylistcss';
import { MultiselectCategoryListViewModelImpl } from './viewmodel/multiselectcategorylistviewmodel';

export class MultiselectCategoryListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private categoryListViewModel: MultiselectCategoryListViewModelImpl;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);

        this.categoryListViewModel = this.getViewModel(applicationContext);
    }

    draw(props: MultiselectCategoryListComponentProps, state: MultiselectCategoryListComponentState, cssStyle: MultiselectCategoryListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
        this.categoryListViewModel.setExistingSelectedCategoriesList(state.seletedCategories);
        this.categoryListViewModel.setIsEdiatble(state.isEditable);
        this.categoryListViewModel.setListDatas(state.listOfDatas);
        this.categoryListViewModel.setTitleCSSStyle(cssStyle.getTitleCSSStyle());

        return (
            <HorizontalListComponent arrowsPaddingType={ArrowsPaddingType.MULTISELECT_CATEGORY} arrowsSizeType={ArrowsSizeType.MULTISELECT_CATEGORY} gutterType={GutterType.MULTISELECT_CATEGORY} title={props.title} listViewModel={this.categoryListViewModel}  marginTopType={MarginTopType.MULTISELECT_CATEGORY} context={props.context}/>
        );
    }

    getSelectedMultiselectCategoryList(): string[]
    {
        console.log("getSelectedMultiselectCategoryList:");
        return this.categoryListViewModel.getSelectedCategoriesList();
    }

    protected getViewModel(applicationContext: BaseContext)
    {
        return new MultiselectCategoryListViewModelImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/multiselectcategorylistview.tsx